import RefClient from 'ref-client-core';
import routing from './configs/external-olp-prd/routing';
import './common';

RefClient.loadConfig(routing);

RefClient.renderRefClient(RefClient.configs, document.getElementById('root'), {});
